import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=7ecc0ac1&scoped=true"
import script from "./TagEdit.vue?vue&type=script&lang=js"
export * from "./TagEdit.vue?vue&type=script&lang=js"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=7ecc0ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecc0ac1",
  null
  
)

export default component.exports